import { render } from "./AtencionesPorMotivo.vue?vue&type=template&id=0a4d8f50&scoped=true"
import script from "./AtencionesPorMotivo.vue?vue&type=script&lang=js"
export * from "./AtencionesPorMotivo.vue?vue&type=script&lang=js"

import "./AtencionesPorMotivo.vue?vue&type=style&index=0&id=0a4d8f50&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4d8f50"]])

export default __exports__